import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../context/AppContext';

export default function PostComposer() {
  const { dispatch, currentUser } = useApp();
  const [content, setContent] = useState('');
  const [images, setImages] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const fileRef = useRef();

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (ev) => setImages((prev) => [...prev, ev.target.result].slice(0, 9));
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (idx) => setImages((prev) => prev.filter((_, i) => i !== idx));

  const handleSubmit = () => {
    if (!content.trim() && images.length === 0) return;
    dispatch({ type: 'ADD_POST', payload: { content: content.trim(), images } });
    setContent('');
    setImages([]);
    setExpanded(false);
  };

  return (
    <div className="composer-wrap">
      <AnimatePresence>
        {!expanded ? (
          <motion.button
            className="composer-trigger"
            onClick={() => setExpanded(true)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
          >
            <div className="trigger-avatar">
              {currentUser.avatar ? (
                <img src={currentUser.avatar} alt="" />
              ) : (
                <span>{currentUser.name[0]}</span>
              )}
            </div>
            <span className="trigger-text">分享你的想法...</span>
            <span className="trigger-icon">📝</span>
          </motion.button>
        ) : (
          <motion.div
            className="composer"
            initial={{ opacity: 0, y: 20, height: 0 }}
            animate={{ opacity: 1, y: 0, height: 'auto' }}
            exit={{ opacity: 0, y: -10, height: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <textarea
              className="composer-input"
              placeholder="说点什么吧..."
              value={content}
              onChange={(e) => setContent(e.target.value)}
              autoFocus
              rows={3}
            />
            {images.length > 0 && (
              <div className="composer-images">
                {images.map((img, i) => (
                  <motion.div
                    key={i}
                    className="composer-img-wrap"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                  >
                    <img src={img} alt="" />
                    <button className="remove-img" onClick={() => removeImage(i)}>×</button>
                  </motion.div>
                ))}
              </div>
            )}
            <div className="composer-actions">
              <button className="btn-icon" onClick={() => fileRef.current.click()}>
                🖼️ 图片
              </button>
              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleImageUpload}
              />
              <div className="composer-btns">
                <button className="btn-cancel" onClick={() => { setExpanded(false); setContent(''); setImages([]); }}>
                  取消
                </button>
                <motion.button
                  className="btn-publish"
                  onClick={handleSubmit}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  disabled={!content.trim() && images.length === 0}
                >
                  发布
                </motion.button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
